import type { ITracing, ITracingProvider } from './types';

export function createTracing(provider: ITracingProvider): ITracing {
  return {
    startSpan(name, options) {
      return provider.startSpan(name, options);
    },
  };
}
